export default __webpack_public_path__ + "static/media/draw-1.0159dd23.jpg";